// ... existing code ...
import { Dialog, DialogContent } from '@mui/material';
import { transparentize } from 'polished';
import { isMobile } from 'react-device-detect';
import styled, { css } from 'styled-components';

const mediaWidths = {
  upToExtra2Small: 320,
  upToExtraSmall: 500,
  upToSmall: 720,
  upToMedium: 960,
  upToLarge: 1280
}
const mediaQuery = (key: keyof typeof mediaWidths) => {
  return `@media (max-width: ${mediaWidths[key]}px)`;
};

const StyledDialogContent = styled(DialogContent) <{ minheight?: number | false; maxheight?: number; mobile?: boolean }>`
  overflow-y: ${({ mobile }) => (mobile ? 'scroll' : 'hidden')};
  margin: 0 0 2rem 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 8px 0 ${({ theme }) => transparentize(0.95, '#2F80ED')};
  padding: 0;
  width: 50vw;
  max-width: 600px;
  display: flex;
  border-radius: 20px;
  border: 1px solid #ffff;
  ${({ maxheight }) => maxheight && css`max-height: ${maxheight}vh;`}
  ${({ minheight }) => minheight && css`min-height: ${minheight}vh;`}

  ${mediaQuery('upToMedium')} {
    width: 65vw;
    margin: 0;
  }

  ${mediaQuery('upToSmall')} {
    width: 85vw;
    ${({ mobile }) => mobile && css`
      width: 95vw;
      border-radius: 10px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
  }
`;

interface ModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  minheight?: number | false;
  maxheight?: number;
  initialFocusRef?: React.RefObject<any>;
  children?: React.ReactNode;
  padding?: number;
}

export default function CustomModal({
  isOpen,
  onDismiss,
  minheight = false,
  maxheight = 90,
  initialFocusRef,
  children,
  padding = 3,
}: ModalProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onDismiss}
      PaperProps={{
        style: {
          position: 'relative',
          opacity: 1, // Set opacity directly
          inset: 'auto',
          border: 'none',
          background: 'none',
          overflow: 'visible',
        },
      }}
    >
      <StyledDialogContent
        aria-label="dialog content"
        minheight={typeof minheight === 'number' ? minheight : undefined} // Ensure minheight is a number
        maxheight={maxheight}
        mobile={isMobile ? true : undefined} // Ensure mobile is a boolean
      >
        <div className="w-full rounded p-px">
          <div className={`flex flex-col h-full w-full rounded p-${padding} overflow-y-auto`}>
            {!initialFocusRef && isMobile ? <div tabIndex={1} /> : null}
            {children}
          </div>
        </div>
      </StyledDialogContent>
    </Dialog>
  );
}
